import React from 'react';

interface TableProps {
  children: React.ReactNode;
  className?: string;
}

export const Table: React.FC<TableProps> = ({ children, className = '' }) => {
  return (
    <table className={`w-full ${className}`}>
      {children}
    </table>
  );
};

interface TableHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const TableHeader: React.FC<TableHeaderProps> = ({ children, className = '' }) => {
  return (
    <thead>
      <tr className={`border-b border-border-primary ${className}`}>
        {children}
      </tr>
    </thead>
  );
};

interface TableBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const TableBody: React.FC<TableBodyProps> = ({ children, className = '' }) => {
  return (
    <tbody className={`divide-y divide-border-primary ${className}`}>
      {children}
    </tbody>
  );
};

interface TableRowProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const TableRow: React.FC<TableRowProps> = ({ children, className = '', onClick }) => {
  return (
    <tr 
      className={`transition-colors hover:bg-white/5 ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
};

interface TableCellProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
  variant?: 'th' | 'td';
  colSpan?: number;
}

export const TableCell: React.FC<TableCellProps> = ({ 
  children, 
  className = '', 
  align = 'left',
  variant = 'td',
  colSpan
}) => {
  const baseClasses = 'px-6 py-4';
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };
  
  if (variant === 'th') {
    return (
      <th 
        className={`${baseClasses} ${alignClasses[align]} text-xs font-medium uppercase tracking-wider text-text-secondary ${className}`}
        colSpan={colSpan}
      >
        {children}
      </th>
    );
  }
  
  return (
    <td 
      className={`${baseClasses} ${alignClasses[align]} ${className}`}
      colSpan={colSpan}
    >
      {children}
    </td>
  );
};